<template>
  <a-layout-sider
    :class="['sider', isDesktop() ? null : 'shadow', theme, fixSiderbar ? 'ant-fixed-sidemenu' : null]"
    width="256px"
    :collapsible="collapsible"
    v-model="collapsed"
    :trigger="null"
  >
    <div class="logo-header">
      <div @click="collapsed ? toggle() : null" style="cursor: pointer; flex: 1; display: flex; align-items: center">
        <logo :show-title="!collapsed" />
      </div>
      <img
        src="/left.png"
        v-if="isDesktop() && !collapsed"
        @click="toggle"
        width="24px"
        height="24px"
        style="position: absolute; top: 24px; right: 15px"
      />
      <!-- <a-icon v-if="isDesktop() && !collapsed" class="menu-trigger" type="left" @click="toggle" style="position: absolute;top: 24px;right: 15px;color:#808080;width: 10px;"/> -->
    </div>
    <div class="sider-content">
      <s-menu
        :collapsed="collapsed"
        :menu="menus"
        :theme="theme"
        :mode="mode"
        @select="onSelect"
        style="padding: 16px 0px"
      ></s-menu>
    </div>

    <div class="user-info-container">
      <a-popover placement="topRight" trigger="click">
        <template slot="content">
          <div class="user-menu" style="min-width: 30px">
            <a-menu style="width: auto !important">
              <a-menu-item key="language" @click="handleSwitchLanguage">
                <a-icon type="global" />
                <span>{{ $t('language.switchLanguage') }}</span>
              </a-menu-item>
              <a-menu-item key="password" @click="handleChangePassword">
                <a-icon type="lock" />
                <span>{{ $t('user.changePassword') }}</span>
              </a-menu-item>
              <a-menu-item key="logout" @click="handleLogout">
                <a-icon type="logout" />
                <span>{{ $t('user.logout') }}</span>
              </a-menu-item>
            </a-menu>
          </div>
        </template>
        <div class="user-info-content">
          <a-avatar :src="avatar" :size="40" />
          <div class="user-info-text" v-if="!collapsed">
            <div class="user-name">{{ nickname }}</div>
            <div class="user-role">{{ roleName }}</div>
          </div>
          <a-icon v-if="!collapsed" type="setting" theme="filled" />
        </div>
      </a-popover>
    </div>

    <modify-password-modal ref="modifyPasswordModal" @success="handlePasswordModified"></modify-password-modal>
    <language-switch-modal ref="languageSwitchModal"></language-switch-modal>
  </a-layout-sider>
</template>

<script>
import Logo from '@/components/tools/Logo'
import SMenu from './index'
import { mixin, mixinDevice } from '@/utils/mixin'
import { mapGetters } from 'vuex'
import ModifyPasswordModal from '@/views/user/ModifyPasswordModal'
import LanguageSwitchModal from '@/views/user/LanguageSwitchModal'

export default {
  name: 'SideMenu',
  components: { Logo, SMenu, ModifyPasswordModal, LanguageSwitchModal },
  mixins: [mixin, mixinDevice],
  props: {
    mode: {
      type: String,
      required: false,
      default: 'inline',
    },
    theme: {
      type: String,
      required: false,
      default: 'dark',
    },
    collapsible: {
      type: Boolean,
      required: false,
      default: false,
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false,
    },
    menus: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['nickname', 'avatar', 'roles']),
    roleName() {
      if (this.roles && this.roles.length > 0) {
        return this.roles[0].name
      }
      return ''
    },
  },
  methods: {
    toggle() {
      this.$emit('toggle')
    },
    onSelect(obj) {
      this.$emit('menuSelect', obj)
    },
    handleSwitchLanguage() {
      this.$refs.languageSwitchModal.open()
    },
    handleChangePassword() {
      this.$refs.modifyPasswordModal.open()
    },
    handlePasswordModified() {
      this.$message.success(this.$t('user.passwordModified'))
    },
    handleLogout() {
      this.$confirm({
        title: this.$t('user.confirmLogout'),
        content: this.$t('user.logoutConfirmContent'),
        okText: this.$t('common.ok'),
        cancelText: this.$t('common.cancel'),
        onOk: () => {
          this.logout()
        },
      })
    },
    logout() {
      this.$store.dispatch('Logout').then(() => {
        this.$router.push('/user/login')
      })
    },
  },
}
</script>

<style lang="less" scoped>
/* Allow side menu text to wrap when overflow */
.sider .ant-menu-item a span,
.sider .ant-menu-submenu-title > span,
.sider .ant-menu-item > a > span {
  white-space: normal !important;
  word-break: break-word !important;
  overflow: visible !important;
  display: inline-block !important;
}

/* Increase line height for multi-line text to maintain readability */
.sider .ant-menu-item a span,
.sider .ant-menu-submenu-title > span {
  line-height: 1.3em;
}

/* Sidebar background color */
.sider {
  background-color: #fff !important;
  border-right: 1px solid #f0f0f0;
}

/* Base menu item styles (sidebar content only) */
.sider-content /deep/ .ant-menu {
  background: transparent !important;
  border-right: none !important;

  /* Submenu arrow direction when expanded (180deg down) */
  .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
    transform: translateY(-50%) rotate(180deg) !important;
  }

  .ant-menu-item,
  .ant-menu-submenu-title {
    // height: auto !important;
    min-height: 50px !important;
    margin: 4px 0 !important;
    padding-left: 32px !important; // Increase left padding, reserve space for arrow
    color: #333 !important;
    font-size: 14px;
    transition: all 0.3s;
    white-space: normal !important;
    display: block !important;
    position: relative;

    /* Move submenu arrow to leftmost position, custom rotation (270deg or -90deg right) */
    .ant-menu-submenu-arrow {
      left: 12px !important;
      right: auto !important;
      top: 18px !important; // Fixed at first row, aligned with icon
      color: #666 !important;
      transition: transform 0.3s !important;
      transform: translateY(-50%) rotate(-90deg) !important;
    }
    > a,
    > span {
      display: flex !important;
      align-items: flex-start !important;
      line-height: 1.4 !important;
      padding: 8px 0 !important;
      width: 100%;
      color: inherit;
    }

    .anticon {
      font-size: 16px;
      margin-right: 10px;
      margin-top: 2px; // Align with first line of text
      color: #666;
      flex-shrink: 0;
    }

    span {
      word-break: break-word;
      flex: 1;
      display: inline-block;
    }
  }

  /* Submenu vertical line */
  .ant-menu-sub {
    position: relative;
    padding-left: 12px !important; // Increase indentation

    &::before {
      content: '';
      position: absolute;
      left: 32px;
      top: 0;
      bottom: 0;
      width: 1px;
      background: #e8e8e8;
      z-index: 1;
    }

    .ant-menu-item {
      padding-left: 48px !important;
      margin: 2px 0 !important;
      height: auto !important;
      min-height: 40px !important;

      &::after {
        display: none; // Remove Ant Design default right selection indicator
      }
    }
  }

  /* Selected state styles */
  .ant-menu-item-selected {
    background: #0c9254 !important;
    color: #fff !important;
    border-radius: 6px;
    margin: 4px 12px !important; // Side padding for rounded rectangle shape
    width: calc(100% - 24px);
    padding-left: 20px !important; // Offset margin-left: 12px for icon alignment

    a {
      color: #fff !important;
    }

    .anticon {
      color: #fff !important;
    }

    /* Force alignment for submenu items when selected */

    /* Selected item indicator dot */
    &::before {
      display: none;
    }
  }
}

.sider {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  position: relative;
  scrollbar-width: none;
  -ms-overflow-style: none;

  .logo-header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    height: 64px;
    overflow: hidden;
    flex-shrink: 0;
    z-index: 10;
    background-color: #fff;
    border-bottom: 1px solid #f0f0f0;

    .logo {
      flex: 1;
      min-width: 0;
      overflow: visible;
      white-space: normal;

      h1 {
        display: inline-block !important;
        vertical-align: middle !important;
        white-space: normal !important;
        overflow: visible !important;
        text-overflow: clip !important;
      }
    }

    .menu-trigger {
      font-size: 20px;
      cursor: pointer;
      color: rgba(255, 255, 255, 0.65);
      transition: color 0.3s;
      padding: 0 16px;
      flex-shrink: 0;
      flex-grow: 0;

      &:hover {
        color: #fff;
      }
    }
  }

  .sider-content {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding-top: 64px;
    padding-bottom: 80px;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .sider-content::-webkit-scrollbar {
    display: none;
  }

  .user-info-container {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    border-top: 1px solid #f0f0f0;
    padding: 16px;
    cursor: pointer;
    transition: all 0.3s;
    z-index: 10;

    .user-info-content {
      display: flex;
      align-items: center;
      gap: 12px;

      .user-info-text {
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .user-name {
          color: #333;
          font-size: 14px;
          font-weight: 500;
          line-height: 1.4;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .user-role {
          color: #999;
          font-size: 12px;
          margin-top: 2px;
          line-height: 1.2;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .anticon-setting {
        color: #666;
        font-size: 18px;
        transition: color 0.3s;

        &:hover {
          color: #0c9254;
        }
      }
    }
  }
}

.sider::-webkit-scrollbar {
  display: none;
}

.user-menu {
  min-width: 150px;

  /deep/ .ant-menu {
    border: none;
    background: #fff !important;

    .ant-menu-item {
      display: flex !important;
      align-items: center !important;
      height: 40px !important;
      line-height: 40px !important;
      padding: 0 16px !important;
      margin: 0 !important;
      color: #333 !important;

      &::before {
        display: none !important; // Ensure no indicator dot appears
      }

      .anticon {
        font-size: 16px;
        margin-right: 8px;
        color: #666;
      }

      &:hover {
        background-color: #f5f5f5 !important;
        color: #0c9254 !important;
        .anticon {
          color: #0c9254 !important;
        }
      }
    }
  }
}

/* Hide scrollbar of a-layout-sider component */
/deep/ .ant-layout-sider {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

/deep/ .ant-layout-sider::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar of ant-menu component */
/deep/ .ant-menu {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

/deep/ .ant-menu::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbars of all child elements */
/deep/ *::-webkit-scrollbar {
  display: none !important;
}

/deep/ * {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}
</style>
